import { render, staticRenderFns } from "./custom-form.vue?vue&type=template&id=4a10b7c6&"
import script from "./custom-form.vue?vue&type=script&lang=js&"
export * from "./custom-form.vue?vue&type=script&lang=js&"
import style0 from "./custom-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports